import { sessionGetJSONItem, sessionSetJSONItem, } from "../services/SessionStorage";
const initialDineInLocationKey = "initialDineInLocation";
export function searchInitialDineInLocationNumber() {
    let searchParams = new URLSearchParams(window.location.search);
    let tableParam = searchParams.get("table");
    if (tableParam) {
        let table = parseInt(tableParam);
        if (!isNaN(table)) {
            return table;
        }
    }
    return null;
}
export function isQrWaiterOrder() {
    const dineInLocation = getDineInLocationNumber();
    return dineInLocation != null;
}
export function getDineInLocationNumber() {
    const initialDineInLocationNumber = searchInitialDineInLocationNumber();
    let sessionDineInLocation = sessionGetJSONItem(initialDineInLocationKey);
    return sessionDineInLocation != null
        ? sessionDineInLocation.number
        : initialDineInLocationNumber;
}
export function setDineInLocation(location) {
    sessionSetJSONItem(initialDineInLocationKey, location);
}
